import { Group, Override } from "@bryntum/schedulerpro";

// This override is not meant to fix a bug rather to change default behavior for all
// component. To avoid setting listeners to every grid.
Override.apply(class {
  static target = {
    class: Group
  }

  construct(...args) {
    this._overridden.construct.call(this, ...args);

    // By default collapse of the group happens on element click listener, which is triggered after `cellClick`
    // event. We need default collapse to finish first, before we can proceed collapsing all groups. So we listen to
    // `toggleGroup` event.
    this.client.on({
      cellClick({ record, event }) {
        if (record.isGroupHeader && event.altKey) {

          this.client.on({
            toggleGroup({ collapse }) {
              if (collapse) {
                this.collapseAll();
              }
            },
            // Remove this listener after 50ms, we don't want to hold it longer in beforeToggleGroup was cancelled
            expire: 50,
            once: true
          });
        }
      },
      thisObj: this
    });
  }

  // patching to this issue => https://github.com/bryntum/support/issues/9913
  // Todo: make sure to check and remove this patch in version 6.0.6
  populateHeaderMenu({ column, items }) {
    this._overridden.populateHeaderMenu.call(this, { column, items });
    if (items.groupAsc) {
      items.groupAsc.onItem = () => this.store.group({ field: column.field, ascending: true });
    }
    if (items.groupDesc) {
      items.groupDesc.onItem = () => this.store.group({ field: column.field, ascending: false });
    }
  }
});
